import { createContext } from 'react';
import type { GuideAnchor, GuideRegistration } from './types';

/**
 * Context object only — the provider component lives in GuideProvider.tsx and
 * the hooks in useGuide.ts, so each file exports one kind of thing (the same
 * split as forms/render/formProjectContext.ts).
 */
export interface GuideState {
  open: boolean;
  setOpen: (open: boolean) => void;
  registration: GuideRegistration | null;
  register: (r: GuideRegistration | null) => void;
  /** Currently highlighted anchor, or null. */
  spotlight: GuideAnchor | null;
  showAnchor: (anchor: GuideAnchor | null) => void;
}

export const GuideContext = createContext<GuideState | null>(null);
